export default __webpack_public_path__ + "static/Bahrain-caa3dbadbaf30e50339f2a636f05a918.png";